// extracted by mini-css-extract-plugin
module.exports = {"DownloadSkillsetJSONButtonWrapper":"_2fCFG"};